__turbopack_context__.v({
  "control": "FormControls-module__h8Kbcq__control",
  "select": "FormControls-module__h8Kbcq__select",
  "textarea": "FormControls-module__h8Kbcq__textarea",
  "visuallyHidden": "FormControls-module__h8Kbcq__visuallyHidden",
});
